import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import Picker from '../../../../components/Common/Picker';
import CValidator from '../../../../components/Common/CValidator';
import List from "../../../../components/Templates/List"
import ListPagination from '../../../../components/Templates/List/ListPagination';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import { useGetAllUsers, useGetListUserDistributionGroupMantainer } from '../../../../hooks/services/NotificationTask/useOfDistributionGroups';
import CLabel from '../../../../components/Common/CLabel';
import { postDistributiongroupList, removeUserDistributionGroup } from '../../../../services/sNotificationAlerts/distributionGroups.service';

const SidePanelMannageAssignations = (props) => {
    const { t } = useTranslation();
  
    const inputParam_IsPanelOpen = props.inputParam_IsPanelOpen !== null && props.inputParam_IsPanelOpen !== undefined ?  props.inputParam_IsPanelOpen : false;
    const inputParam_SetterIsPanelOpen = props.inputParam_SetterIsPanelOpen !== null && props.inputParam_SetterIsPanelOpen !== undefined ?  props.inputParam_SetterIsPanelOpen : null;
    const inputParam_EditMode = props.inputParam_EditMode !== null && props.inputParam_EditMode !== undefined ?  props.inputParam_EditMode : false;
    const inputParam_ItemToEdit = props.inputParam_ItemToEdit !== null && props.inputParam_ItemToEdit !== undefined ?  props.inputParam_ItemToEdit : null;
    const inputParam_DistributionGroupId = props.inputParam_DistributionGroupId !== null && props.inputParam_DistributionGroupId !== undefined ?  props.inputParam_DistributionGroupId : null;

    const buttonAddStyles = { root: { float: "right" } };
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [message, setMessage] = useState(null);
    const [showMessage, setShowMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
        
    const [isInvalidList, setIsInvalidList] = useState(false);

    const [userList, setUserList] = useState(null);
    useGetAllUsers(userList, setUserList);

    const [assignamentUserList, setAssignamentUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    useGetListUserDistributionGroupMantainer(inputParam_DistributionGroupId, assignamentUserList, setAssignamentUserList, inputParam_IsPanelOpen)

    const [selectedPickerUsers, setSelectedPickerUsers] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});

    const [isInvalidUserSelector, setIsInvalidUserSelector] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        setIsInvalidList(false);
        setIsInvalidUserSelector(false);
        setShowMessage(false);
        
        setAssignamentUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
    };

    const onSaveUsers = () => {
        const isValidForm = assignamentUserList.data !== null && assignamentUserList.data.length > 0;

        if (isValidForm) {
            let usersToSave = [];

            assignamentUserList.data.filter(x => x.id <= 0).forEach(member => {
                usersToSave.push({
                    id: member.id,
                    distributionGroupId: inputParam_DistributionGroupId,
                    username: member.username,
                    firstname: member.firstname,
                    lastname: member.lastname,
                    userAuthProfileId: member.userAuthProfileId !== null && member.userAuthProfileId !== undefined ? member.userAuthProfileId : 0,
                    principal: member.principal
                })
            });

            postDistributiongroupList(usersToSave).then((response) => {
                //No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
                //Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
                //setAssignamentUserList(null);
                setAssignamentUserList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: null
                }));
                setSelectedPickerUsers(prevState => ({
                    ...prevState,
                    data: null
                }));

                setUserList(null);
                setIsInvalidUserSelector(false);

                setShowMessage(true)
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed'))
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
            //Enviar a guardar los usuarios seleccionados en la lista de distribución de la parte en el libro.

            setIsInvalidUserSelector(false);
        }
        else {
            setIsInvalidList(true)
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setAssignamentUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: null
        }));
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onChangeUser = (currentNode, selectedNodes) => {
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: selectedNodes
        }));

        userList.forEach(x => {
            x.checked = x.username === currentNode.username ? currentNode.checked : x.checked;
        })

        setUserList(userList);
        setIsInvalidUserSelector(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            {
                inputParam_EditMode && assignamentUserList.data && assignamentUserList.data.length > 0 &&
                <PrimaryButton onClick={ onSaveUsers } styles={_global_buttonStyles}>{t('data-lang-btn-save')}</PrimaryButton>
            }
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div>
    }

    const onAddUserToUserList = () => {
        const isValidUserSelector = selectedPickerUsers.data !== null && selectedPickerUsers.data.length > 0;

        if (isValidUserSelector) {
 
            let idFlyItems = assignamentUserList.data.length > 0 ? assignamentUserList.data.reduce(function(prev, curr) {
                return parseInt(prev.id) < parseInt(curr.id) ? prev : curr;
            }) : null;

            for (let index = 0; index < selectedPickerUsers.data.length; index++) { 
                let _aux_index = index + 1;

                let element = selectedPickerUsers.data[index]
                let aux_index = idFlyItems !== null ? ((parseInt(idFlyItems.id) > 0)? _aux_index : parseInt(idFlyItems.id - _aux_index)) : 1;

                let duplicated = assignamentUserList.data.find(x => x.username === element.username);

                if(duplicated === null || duplicated === undefined) {
                    assignamentUserList.data.push({
                        principal: element.principal,
                        id: aux_index * -1,
                        distributionGroupId: 0,
                        userAuthProfileId: element.userAuthProfileId,
                        username: element.username,
                        firstname: element.firstname,
                        lastname: element.lastname,
                    });
                }
                else {
                    setShowMessage(true)
                    setMessageType("warning");
                    setMessage(t('data-lang-msg-someitemsalredyexist'))
                }
            }            

            setAssignamentUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: assignamentUserList.data
            }));
            
            setSelectedPickerUsers(prevState => ({
                ...prevState,
                data: null
            }));

            userList.map(x => x.checked = false)
            setUserList(userList);

            setIsInvalidUserSelector(false);
            setIsInvalidList(false);
        }
        else {
            setIsInvalidUserSelector(!isValidUserSelector);
        }
    }

    const onDeleteUserFromListClick = (item, setItemToDelete) => {
        if (item.id > 0) {
            removeUserDistributionGroup(item.id).then((response) => {
                //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
                //De lo contrario tendría dos cosas iguales.
                if (response.data.succeeded) {

                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))

                    setItemToDelete(item);
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        else {
            setItemToDelete(item);
        }
    }

    const ManipulateRowButtonsDisplay = (itemId) => {
        let elementsRowView = document.getElementsByClassName(`rowView${itemId}`);
        let elementsRowEdit = document.getElementsByClassName(`rowEdit${itemId}`);
        let elementBtnMantSave = document.getElementById(`btnMantSave${itemId}`);
        let elementBtnMantEdit = document.getElementById(`btnMantEdit${itemId}`);
        let elementBtnMantCancel = document.getElementById(`btnMantCancel${itemId}`);
        
        const isHiddenItem = elementsRowView[0].style.display === "none";

        if (isHiddenItem) {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });

            elementBtnMantSave.style.display = "none";
            elementBtnMantCancel.style.display = "none";
            elementBtnMantEdit.style.display = "block";
        }
        else {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });

            elementBtnMantSave.style.display = "block";
            elementBtnMantCancel.style.display = "block";
            elementBtnMantEdit.style.display = "none";
        }
    }

    //Por alguna razon el evento click que deberia borrar no funciona, no obtiene el valor de la lista de clientes, la obtiene con el valor inicial, que es nula.
    //Esta fue la unica forma en la que se pudo borrar el item. Posiblemente se vea en otros lugares esta misma implementacion. Buscar por #CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newUserList = [];

        assignamentUserList.data.forEach(obj => {
            if (obj.username !== itemToDelete.username) {
                newUserList.push(obj)
            }
        })

        setAssignamentUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newUserList
        }));
        
        setItemToDelete(null);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-assignusers') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_EditMode === true &&
                    <>
                        <Row className='pt-1'>
                            <Col xs={12} xl={6} className="mt-1">
                                <CLabel labelText={ t('data-lang-lbl-nemo') } labelValue={inputParam_ItemToEdit.distributionGroupNemo} />
                            </Col>
                            <Col xs={12} xl={6} className="mt-1">
                                <CLabel labelText={ t('data-lang-lbl-code') } labelValue={inputParam_ItemToEdit.distributionGroupCode} />
                            </Col>
                        </Row>
                        <Row className='pt-1'>
                            <Col xs={12} xl={12} className="mt-1">
                                <CLabel labelText={ t('data-lang-lbl-name') } labelValue={inputParam_ItemToEdit.name} />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ userList !== null ? userList : [] }
                                    mode="multiSelect"
                                    className="dropdown-checkbox remove-position"
                                    isInValid={ isInvalidUserSelector }
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangeUser }
                                    labelText={ t('data-lang-lbl-bookusers') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidUserSelector } />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <PrimaryButton onClick={ onAddUserToUserList } styles={buttonAddStyles}>{t('data-lang-btn-add')}</PrimaryButton>
                            </Col>
                        </Row>
                    </>
                }
                <Row className="pt-3">
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="messageAssignamentToCooperate"
                            className="no-compact-list big-header"
                            manipulateLocalData={ true }
                            setData={setAssignamentUserList}
                            data={assignamentUserList}
                            columns={[
                                {
                                    key: 'username',
                                    name: t('data-lang-lbl-username'),
                                    fieldName: 'username',
                                    minWidth: 480,
                                    maxWidth: 480,
                                    onRender:(item) => {
                                        return <div title={item.username}>{ item.firstname }&nbsp;{ item.lastname }</div>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    minWidth: 30,
                                    maxWidth: 30,
                                    onRender:(item, row) => {
                                        return  <>
                                                {
                                                    inputParam_EditMode === true && <div className='d-flex'>
                                                        <ActionButton className='mx-auto' id={`btnMantDelete${item.id}`} iconProps={{ iconName: 'Delete' }} onClick={() => onDeleteUserFromListClick(item, setItemToDelete)} allowDisabledFocus >
                                                        </ActionButton>
                                                    </div>
                                                }
                                                </>
                                    }
                                }
                            ]}
                        />
                        <CValidator isInValid={isInvalidList} />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-paginnation d-none">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="messageAssignamentToCooperate"
                            data={ assignamentUserList }
                            setData={ setAssignamentUserList } />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-message">
                        <MessageBox inputParam_Message={ message } inputParam_Display={ showMessage === null? false : showMessage } inputParam_MessageType={messageType} inputParam_SetterMessage={ setShowMessage } />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelMannageAssignations;